module.exports = __webpack_public_path__ + "static/media/ei08.ffd8dcc1.png";